import styled from '@emotion/styled'

// puts a margin and black background under the iOS status bar
export const L1StatusBarBackground = styled.div(({theme}) => ({
	height: theme.statusBarHeightPx + 'px',
	backgroundColor: 'black',
	display: theme.statusBarHeightPx > 0 ? 'initial' : 'none',
}))
